'use client';
import { _ as _extends, a as _object_destructuring_empty, b as _object_without_properties_loose } from './cc-Cfl-u3id.js';
import { jsx } from 'react/jsx-runtime';
import { onLoad } from '@repo/lib';
import { getImageProps } from 'next/image';

function Image(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    let { placeholder } = props;
    const { blurDataURL, style } = props;
    if (blurDataURL) {
        placeholder = "blur";
    }
    var _props_alt;
    const _getImageProps = getImageProps(_extends({}, props, {
        alt: (_props_alt = props.alt) != null ? _props_alt : "",
        placeholder
    })), { props: { style: imgStyle } } = _getImageProps, imgProps = _object_without_properties_loose(_getImageProps.props, [
        "style"
    ]);
    return /*#__PURE__*/ jsx("img", _extends({}, imgProps, {
        style: _extends({}, imgStyle, style),
        fetchPriority: props.preload ? "high" : "auto",
        onLoad: (event)=>{
            const img = event.currentTarget;
            var _props_delay;
            setTimeout(()=>{
                onLoad(img);
            }, (_props_delay = props.delay) != null ? _props_delay : 0);
            if (props.onLoad) {
                props.onLoad(event);
            }
        }
    }));
}

export { Image };
